<!--
 * @Author: AnNa
 * @Date: 2021-08-09 11:29:15
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-19 09:55:42
 * @Description:
-->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 21 }" @submit="handleSubmit">
      <a-form-item>
        <a-textarea
          :rows="5"
          allowClear
          placeholder="多个口令请用英文逗号分开"
          v-decorator="['free_item', { rules: [{validator: validateItem }] }]"
        />
        <a-button :loading="confirmLoading" type="primary" htmlType="submit" style="margin-top: 10px">增加口令</a-button>
      </a-form-item>

    </a-form>
  </div>
</template>

<script>
import { LuckyAPI } from '@/api/lucky'
import { to } from '@/utils/await'
import { message } from 'ant-design-vue'

export default {
  data() {
    return {
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      visible: false,
      confirmLoading: false,
      currentRobotId: null,
      info: null,
      luckys: [],
      goods: []
    }
  },
  props: {
    ids: Object
  },
  methods: {
    validateItem(rule, value, callback) {
      const errors = []
      try {
        value.split(',')
      } catch (e) {
        // console.log(e)
        errors.push(new Error('口令格式不正确，请检查！'))
      }
      callback(errors)
    },
    show(record) {
      this.ids = record
      this.info = record
      this.visible = true
      this.$nextTick(() => this.handleLoadLucky())
    },
    handleChange(e) {
      this.handleLoadGoods(e)
    },

    copyText(text) {
      this.$copyText(text)
      this.$message.success('复制成功')
    },
    copyEmoji(emoji) {
      this.$copyText(emoji)
      this.$message.success('表情复制成功')
    },
    handleSelectSub() {
      this.$refs.robot.show()
    },

    async handleLoadLucky() {
      const { data } = await LuckyAPI.getList({
        sub_id: this.currentRobotId
      })
      this.luckys = [...data]
    },
    async handleLoadGoods(id) {
      const { data } = await LuckyAPI.getGoodsList({
        sub_id: this.currentRobotId,
        search_condition: 2,
        keywords: id
      })
      this.goods = [...data]
    },

    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.confirmLoading = true
          const [msg] = await to(LuckyAPI.addFree(
            { ...values,
              ...this.ids
            }))
          this.confirmLoading = false
          if (!msg) {
            this.visible = false
            this.form.resetFields()
            this.$emit('ok')
            message.success('操作成功')
            return
          }

          message.success(msg)
        }
      })
    },
    handleCancel() {
      this.visible = false
    },
    handleOk(record) {
      this.form.setFieldsValue({
        robot_id: record.id,
        servant_id: record.servant_id
      })
    }
  }
}
</script>
